import React from 'react';
import { withStyles, WithStyles, createStyles, Theme } from '@material-ui/core';

import units from 'ha/theme/units';
import Row from 'ha/ui/next/Row';
import { CloseBtn } from 'ha/ui/next/Modal';
import Popper from 'ha/ui/next/Popper';
import SearchAlertButton, {
  OuterProps,
} from '../../containers/SearchAlerts/SearchAlertButton';
import SearchAlertConfirmation from '../../containers/SearchAlerts/SearchAlertConfirmation';
import SearchAlertConfirmationButton from '../../containers/SearchAlerts/SearchAlertConfirmationButton';

interface Props {
  isAuthenticated: boolean;
  isDisabled: boolean;
  buttonProps?: OuterProps;
}

const styles = (t: Theme) =>
  createStyles({
    content: {
      padding: units.yx(1, 1.5),
      maxWidth: units.rem(25),
    },
    buttonContainer: {
      padding: units.rem(1.5),
      borderTop: units.border(1, 'solid', t.palette.grey[300]),
    },
    button: {
      width: '100%',
    },
  });

export const SearchAlertDesktop: React.FC<
  Props & WithStyles<typeof styles>
> = ({ classes, isAuthenticated, isDisabled, buttonProps = {} }) => (
  <Popper
    anchor={
      <SearchAlertButton
        color={buttonProps.color}
        variant={buttonProps.variant}
      />
    }
    isDisabled={[!isAuthenticated, isDisabled].some(Boolean)}
  >
    {({ handleClose }) => (
      <Row direction="column" wrap="nowrap">
        <CloseBtn onClose={handleClose} />
        <div className={classes.content}>
          <SearchAlertConfirmation />
        </div>
        <div className={classes.buttonContainer}>
          <SearchAlertConfirmationButton
            onClick={handleClose}
            className={classes.button}
          />
        </div>
      </Row>
    )}
  </Popper>
);

export default withStyles(styles)(SearchAlertDesktop);
